import { stlHotspot } from '@utils/ModuleResources';
export default class Hotspots {
  constructor(context, data) {
    this.createHotspots(context, data);
  }
  createHotspots(mediaContainer, hotspotData) {
    hotspotData.forEach((hotspot, index) => {
      hotspot.index = parseInt(index) + 1;
      mediaContainer.innerHTML += stlHotspot(hotspot);

      if (hotspotData.length - 1 == index) {
        this.initEventListeners(mediaContainer);
      }
    });
  }

  initEventListeners(context) {
    context.querySelectorAll('.stl--hotspot').forEach((hotspot) => {
      const popupTitle = hotspot.getAttribute('data-title');
      hotspot.querySelector('.icon-hotspot').addEventListener('mouseenter', () => {
        document.querySelectorAll(`.stl--hotspot-popup`).forEach((hotspot) => {
          hotspot.classList.remove('active');
        });

        context.querySelector(`.stl--hotspot-popup[data-title="${popupTitle}"]`).classList.toggle('active');
      });

      hotspot.querySelector('.icon-hotspot').addEventListener('click', () => {
        context.querySelector(`.stl--hotspot-popup[data-title="${popupTitle}"]`).classList.toggle('active');
      });
      hotspot.querySelector('.stl--hotspot-popup').addEventListener('mouseleave', () => {
        hotspot.querySelector('.stl--hotspot-popup').classList.remove('active');
      });

      document.addEventListener('scroll', () => {
        this.getHotspotPosition(hotspot.querySelector('.icon-hotspot'));
      });

      function checkParent(parent, child) {
        if (parent.contains(child)) return true;
        return false;
      }

      context.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        // Close hotspot popup when you click out of it
        if (!checkParent(context, e.target)) {
          document.querySelector('.stl--hotspot-popup.active')?.classList.remove('active');
        }
      });
    });
  }
  getHotspotPosition(hotspot) {
    const rect = hotspot.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const viewportHeight = document.documentElement.clientHeight;

    function setHotspotAttribute(direction) {
      hotspot.parentNode.querySelector('.stl--hotspot-popup').setAttribute('data-quadrant', direction);
    }

    if (rect.left < viewportWidth / 2 && rect.top < viewportHeight / 2) {
      //the hotspot SVG is in the top left browser quadrant, and the corresponding popup should be positioned relative to the bottom right of the icon
      setHotspotAttribute('top-left');
    } else if (rect.left >= viewportWidth / 2 && rect.top < viewportHeight / 2) {
      //the hotspot SVG is in the top right browser quadrant, and the corresponding popup should be positioned relative to the bottom left of the icon
      setHotspotAttribute('top-right');
    } else if (rect.left < viewportWidth / 2 && rect.top >= viewportHeight / 2) {
      //the hotspot SVG is in the bottom left browser quadrant, and the corresponding popup should be positioned relative to the top right of the icon
      setHotspotAttribute('bottom-left');
    } else if (rect.left >= viewportWidth / 2 && rect.top >= viewportHeight / 2) {
      //the hotspot SVG is in the bottom right browser quadrant, and the corresponding popup should be positioned relative to the top left of the icon
      setHotspotAttribute('bottom-right');
    }
  }
}
